import styles from "./navbar.module.scss";
import React from "react";
import { LinkBtn } from "@/components/layout/navbar/link-btn";
import {
  LinkMenuBtn,
  MenuLinkButtonProps,
  MenuLinkProps,
} from "@/components/layout/navbar/menu-link-btn";

export type LinkType = {
  name: string;
  url?: string;
  direction?: "left" | "right";
  columns?: MenuLinkProps["columns"];
  childLinks?: MenuLinkButtonProps[];
};

export type NavLinksProps = {
  links: LinkType[];
};

const NavLinks = ({ links }: NavLinksProps) => {
  return (
    <ul className={styles.links}>
      {links.map((link) => {
        if (link.childLinks)
          return (
            <li key={link.name}>
              <LinkMenuBtn
                name={link.name}
                links={link.childLinks}
                direction={link.direction}
                size="large"
                columns={link.columns}
              />
            </li>
          );
        else if (link.url)
          return (
            <li key={link.name}>
              <LinkBtn link={link.url} name={link.name} />
            </li>
          );
      })}
    </ul>
  );
};

export default NavLinks;
